import { post } from './http'

function showError(loaddom, comfirmdom, message) {
  if (loaddom) {
    loaddom.hidden()
  }
  if (comfirmdom) {
    comfirmdom.show(message || 'An error has occurred.', {
      type: 'alert',
    })
  }
}

export function callPost(
  url,
  data,
  loaddom,
  confirmdom,
  loadmessage,
  fHandleRejection = false
) {
  return new Promise((resolve, reject) => {
    if (loaddom) {
      loaddom.show(loadmessage)
    }
    post(url, data)
      .then((res) => {
        if (loaddom) {
          loaddom.hidden()
        }
        var data = res.data

        if (data.isSuccess != null && data.isSuccess != undefined) {
          if (data.isSuccess) {
            resolve(data.result)
          } else {
            showError(loaddom, confirmdom, data.errorMessage)
            if (fHandleRejection) {
              reject(data.result)
            }
          }
        } else {
          resolve(data)
        }
      })
      .catch((res) => {
        var message = ''
        if (res.data && res.data.error && res.data.error.message) {
          message = res.data.error.message
        } else {
          message = 'sms api request failed, please sign out to try again'
        }
        showError(loaddom, confirmdom, message)

        if (fHandleRejection) {
          reject(res.data)
        }
      })
  })
}
